import React from 'react';
import { createRoot } from 'react-dom/client';
import toast from 'react-hot-toast';
import { getLesson, getLessonImage } from '../services/studentService';
import VariantBlank from '../components/Student/VariantBlank';
import { exportPagesToPdf } from './domToPdf';

/* Скачать бланк варианта одной кнопкой, без перехода на отдельную страницу:
   собираем листы в невидимом контейнере, снимаем с них PDF и убираем за собой. */
export async function downloadVariantPdf(lessonId, title) {
  const id = toast.loading('Готовим PDF…');
  let host = null, root = null;
  try {
    const res = await getLesson(lessonId);
    const lesson = res?.data;
    if (!lesson?.Homework?.length) throw new Error('в варианте нет заданий');

    host = document.createElement('div');
    host.style.cssText = 'position:fixed;left:-10000px;top:0;width:794px;';
    document.body.appendChild(host);
    root = createRoot(host);

    const pages = await new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('бланк не собрался')), 30000);
      root.render(
        <VariantBlank lesson={lesson} onReady={(els) => { clearTimeout(timer); resolve(els); }} />
      );
    });
    if (!pages.length) throw new Error('пустой бланк');

    toast.loading('Собираем PDF…', { id });
    const name = `${(title || lesson.title || 'Вариант').replace(/[\\/:*?"<>|]/g, ' ').trim()}.pdf`;
    await exportPagesToPdf(pages, name, null, { imageProxy: (url) => getLessonImage(lessonId, url) });
    toast.success('Файл сохранён', { id });
  } catch (e) {
    console.error('PDF:', e);        // иначе причина теряется и чинить нечего
    toast.error('Не удалось собрать PDF', { id });
  } finally {
    if (root) setTimeout(() => root.unmount(), 0);
    if (host) setTimeout(() => host.remove(), 200);
  }
}
